(function() {
'use strict';

angular
    .module('TR')
    .service('marhabaSearch', marhabaSearch);

function marhabaSearch(marhabaSearchValidator,
                       searchUnitService,
                       occupancyService,
                       $http,
                       $q,
                       tripService,
                       analytics) {
    const url = '/api2/marhaba/';
    const domain = TRPCONFIG.Domain;
    const req = {
        CultureCode: domain.CultureCode,
        CurrencyCode: domain.CurrencyCode,
        DomainId: domain.DomainId
    };
    let inProgress;
    let results;

    const service = {
        clearSearchResults,
        getSearchResults,
        search,
        validateSearchCriteria
    };

    function _doRequest(request, newSearch) {
        const simpleRequest = {
            AvailabilitySearchId: request.AvailabilitySearchId,
            CultureCode: request.CultureCode,
            CurrencyCode: request.CurrencyCode,
            DomainId: request.DomainId,
            TerminalId: request.Terminal.Id,
            FlightType: searchUnitService.getMarhabaFlightType(request.FlightType.Id),
            AirportCode: request.Airport.Code,
            DateAndTime: request.DateAndTime,
            Occupancy: request.Occupancy,
            StaffRates: request.StaffRates
        };
        return newSearch ?
            $http.post(`${url}availability/get`, simpleRequest) :
            $http.post(`${url}availability/getfromsession`, { AvailabilitySearchId: request.AvailabilitySearchId });
    }

    function _childrenAndInfants(childAges) {
        const numberOf = {};
        numberOf.children = 0;
        numberOf.infants = 0;
        for (let i = childAges.length - 1; i >= 0; i--) {
            if (childAges[i] <= 2) {
                numberOf.infants++;
            } else {
                numberOf.children++;
            }
        }
        return numberOf;
    }

    function _obtainSearchParameters() {
        req.Terminal = searchUnitService.getTerminal();
        req.FlightType = searchUnitService.getFlightType();
        req.Airport = searchUnitService.getMarhabaAirport();
        req.DateAndTime = searchUnitService.startDate(searchUnitService.marhaba);
        const occupancy = occupancyService.reduceOccupancy();
        const kiddos = _childrenAndInfants(occupancy.ChildAges);
        req.Occupancy = { Adults: occupancy.Adults, Children: kiddos.children, Infants: kiddos.infants, ChildAges: occupancy.ChildAges }; //occupancyService.getOccupancy();
        req.StaffRates = searchUnitService.getStaffRates();
    }

    function _search(newSearch) {
        if (inProgress) {
            return inProgress;
        }

        inProgress = _doRequest(req, newSearch)
            .then(function(res) {
                req.AvailabilitySearchId = res.data.AvailabilitySearchId;
                results = res.data;
                inProgress = null;
                return results;
            }, function() {
                inProgress = null;
                results = null;
            });

        return inProgress;
    }

    function clearSearchResults() {
        results = null;
    }

    function getSearchResults(searchId, trip) {
        return (results && results !== 'null') ? $q.when(results) : service.search({ searchId, trip });
    }

    function search(args) {
        req.AvailabilitySearchId = args.searchId;

        // programmatically defined parameter
        if (args.parameters) {
            angular.extend(req, args.parameters);
        } else if (!args.parameters) {
            if (args.trip) {
                searchUnitService.restoreMarhabaSearch(args.trip);
            }
            _obtainSearchParameters();
        }

        if (args.newSearch) {
            analytics.track('mixpanel', 'Search', _.extend({}, req, { TypeTitle: 'Marhaba' }));
            tripService.recordMarhabaSearch(args.tripId, _.mapValues(req, (v, k) => k === 'FlightType' ? v.Id : v));
        }

        return _search(args.newSearch);
    }

    function validateSearchCriteria(parameters) {
        if (parameters) {
            return marhabaSearchValidator.validate(
                parameters.Terminal,
                parameters.AirportCode,
                parameters.DateAndTime,
                parameters.Occupancy
            );
        }

        return marhabaSearchValidator.validate(
            searchUnitService.getTerminal(),
            searchUnitService.getMarhabaAirport(),
            searchUnitService.startDate(searchUnitService.marhaba),
            occupancyService.getOccupancy()[0]
        );
    }

    return service;
}
})();
